import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { AdminsIcon, AthletesIcon, CancelIcon, ChevronDownIcon, CustomizePlanIcon, EmailIcon, InfoIcon, InvoiceIcon } from "../modals/icons/icons";
import { useNavigate } from "react-router-dom";
import PlansModal from "../modals/plans-modal";

const TAX_REGIME_OPTIONS = [
    { value: 10, label: "01 - IVA" },
    { value: 20, label: "04 - INC" },
    { value: 30, label: "ZA - IVA e INC" },
    { value: 40, label: "ZZ - No aplica" }
];

const TAX_RESPONSIBILITY_OPTIONS = [
    { value: 10, label: "O-13 Gran Contribuyente" },
    { value: 20, label: "O-15 Autorretenedor" },
    { value: 30, label: "O-23 Agente de retención IVA" },
    { value: 40, label: "O-47 Régimen simple de tributación" },
    { value: 50, label: "R-99-PN No aplica - Otros" }
];

export default function PlanCustomizationAndBilling({
    planData,
    selectedPlanName,
    handleSelectPlan,
    availablePlans,
    billingPeriod,
    setBillingPeriod,
    totalAdmins,
    totalAthletes,
    handleDecrementAdmins,
    handleIncrementAdmins,
    handleDecrementAthletes,
    handleIncrementAthletes,
    getAdminsDiff,
    getAthletesDiff,
    selectedPlanIncluded,
    showInvoice,
    setShowInvoice,
    invoiceData,
    handleInvoiceDataChange,
    isBlockedByPendingChanges,
    loading
}) {
    const navigate = useNavigate();
    const [showPlansModal, setShowPlansModal] = useState(false);

    const handlePlanSelectionFromModal = (data) => {
        const planName = data.backendPlan?.name || data.frontendPlan.name;
        handleSelectPlan(planName);
        if (data.billingPeriod) {
            setBillingPeriod(data.billingPeriod);
        }
        setShowPlansModal(false);
    }

    return (
        <div className={`col-lg-7  ${isBlockedByPendingChanges ? "opacity-25 pe-none" : " "}`} >
            {loading ?
                (
                    <>
                        <div className="subscription-edit-current-plan card mb-4 p-3 h-25">
                            <div className="loading-skeleton h-100" />
                        </div>

                        <div className="subscription-edit-customize card mb-4 d-flex flex-column gap-3 h-50 p-3">
                            <div className="loading-skeleton h-100" />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="subscription-edit-current-plan card mb-4 p-3">
                            <div className="w-100 d-flex flex-row justify-content-between align-items-start">
                                <div className="d-flex flex-column align-self-center gap-2">
                                    <h5 className="subscription-edit-current-title mb-0">Tu plan actual</h5>
                                    <h4 className="subscription-edit-plan-name mb-0">
                                        {planData?.plan_title}{" "}
                                        <span className="subscription-edit-plan-tag">
                                            ({planData?.current_payment_form?.includes("Anual") ? "Anual" : "Mensual"})
                                        </span>
                                    </h4>
                                    <span className="subscription-edit-renew">
                                        Renovación automática: {planData?.next_payment_due_date}
                                    </span>
                                </div>

                                <div className="text-end subscription-edit-meta d-flex flex-column align-items-start gap-2">
                                    <span className="subscription-edit-meta-status">
                                        {planData?.is_trial ? "Prueba Gratuita" : "Contratado"}
                                    </span>
                                    <div className="subscription-edit-meta-athletes">
                                        <AthletesIcon />
                                        {planData?.client_slots_used} / {planData?.contracted_client_slots} Atletas
                                    </div>
                                    <div className="subscription-edit-meta-athletes">
                                        <AdminsIcon />
                                        {planData?.admin_slots_used} / {planData?.contracted_admin_users} Admins
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="subscription-edit-customize card mb-4 d-flex flex-column gap-3">
                            <div className="subscription-edit-customize-header d-flex justify-content-between align-items-center p-3">
                                <h5 className="subscription-edit-section-title mb-0">
                                    <CustomizePlanIcon />
                                    Personaliza tu Nuevo Plan
                                </h5>
                            </div>

                            <div className="p-3 pt-1 d-flex flex-column gap-3">
                                <div className="subscription-edit-customize-plan p-3 d-flex flex-column gap-3">
                                    <div className={`subscription-edit-plan-selector`}>
                                        <label className="subscription-edit-label mb-2 d-flex flex-row align-items-center justify-content-between">
                                            PLAN BASE
                                            <span
                                                className="subscription-edit-label-tag d-flex flex-row align-items-center gap-1 cursor-pointer"
                                                onClick={() => setShowPlansModal(true)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <InfoIcon />
                                                Comparar planes
                                            </span>
                                        </label>

                                        <Dropdown className="subscription-edit-dropdown subscription-edit-select">
                                            <Dropdown.Toggle
                                                className="w-100 d-flex justify-content-between align-items-center subscription-edit-dropdown-btn"
                                            >
                                                {selectedPlanName}
                                                <ChevronDownIcon />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="subscription-edit-select-menu w-100">
                                                {availablePlans.map(plan => (
                                                    <Dropdown.Item
                                                        key={plan.id}
                                                        onClick={() => handleSelectPlan(plan.name)}
                                                    >
                                                        {plan.name}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                    <div className={`subscription-edit-frequency`}>
                                        <label className="subscription-edit-label mb-2">FRECUENCIA DE PAGO</label>

                                        <div className="subscription-edit-frequency-tabs d-flex">
                                            <button
                                                className={`subscription-edit-frequency-btn flex-grow-1 ${billingPeriod === "monthly" ? "active" : ""}`}
                                                onClick={() => setBillingPeriod("monthly")}
                                            >
                                                Mensual
                                            </button>
                                            <button
                                                className={`subscription-edit-frequency-btn flex-grow-1 ${billingPeriod === "yearly" ? "active" : ""}`}
                                                onClick={() => setBillingPeriod("yearly")}
                                            >
                                                Anual
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="subscription-edit-divider" />

                                <div className={`subscription-edit-users d-flex flex-column justify-content-center align-items-center gap-3 p-3`}>

                                    <div className="subscription-edit-user-block d-flex flex-column align-items-center justify-content-center gap-2 w-100">
                                        <div className="d-flex justify-content-between align-items-center gap-3 w-100">
                                            <div className="subscription-edit-user-title d-flex align-items-center gap-2">
                                                <AthletesIcon />
                                                <span>Usuarios Administrativos</span>
                                            </div>
                                            {(() => {
                                                const diff = getAdminsDiff();
                                                if (diff === 0) return null;

                                                return (
                                                    <span
                                                        className={`user-diff-chip ${diff > 0 ? "user-diff-add" : "user-diff-remove"
                                                            }`}
                                                    >
                                                        {diff > 0 ? `+${diff} Nuevos` : `${diff} Removidos`}
                                                    </span>
                                                );
                                            })()}
                                        </div>

                                        <div className="subscription-edit-user-input-container d-flex flex-row gap-3 align-items-center justify-content-between p-1 w-100">
                                            <button className="subscription-edit-user-btn" onClick={handleDecrementAdmins}>-</button>
                                            <input type="number" className="subscription-edit-user-input" value={totalAdmins} readOnly />
                                            <button className="subscription-edit-user-btn" onClick={handleIncrementAdmins}>+</button>
                                        </div>

                                        <div className="subscription-edit-user-info d-flex justify-content-between align-items-center w-100">
                                            <span>Incluye {selectedPlanIncluded.included_admins} administrativos</span>
                                            <span className="fw-bolder">COP ${selectedPlanIncluded.extra_admin_price.toLocaleString("es-CO")} / mes extra por usuario</span>
                                        </div>
                                    </div>

                                    <div className="subscription-edit-user-block d-flex flex-column align-items-center justify-content-center gap-2 w-100">
                                        <div className="d-flex justify-content-between align-items-center gap-3 w-100">
                                            <div className="subscription-edit-user-title d-flex align-items-center gap-2">
                                                <AthletesIcon />
                                                <span>Atletas</span>
                                            </div>
                                            {(() => {
                                                const diff = getAthletesDiff();
                                                if (diff === 0) return null;

                                                return (
                                                    <span
                                                        className={`user-diff-chip ${diff > 0 ? "user-diff-add" : "user-diff-remove"
                                                            }`}
                                                    >
                                                        {diff > 0 ? `+${diff} Nuevos` : `${diff} Removidos`}
                                                    </span>
                                                );
                                            })()}
                                        </div>

                                        <div className="subscription-edit-user-input-container d-flex flex-row gap-3 align-items-center justify-content-between p-1 w-100">
                                            <button className="subscription-edit-user-btn" onClick={handleDecrementAthletes}>-</button>
                                            <input type="number" className="subscription-edit-user-input" value={totalAthletes} readOnly />
                                            <button className="subscription-edit-user-btn" onClick={handleIncrementAthletes}>+</button>
                                        </div>

                                        <div className="subscription-edit-user-info d-flex justify-content-between align-items-center w-100">
                                            <span>Mínimo {selectedPlanIncluded.included_clients} usuarios para este plan</span>
                                            <span className="fw-bolder">COP ${selectedPlanIncluded.extra_client_price.toLocaleString("es-CO")} / mes extra por usuario</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="subscription-edit-billing card p-3 mb-4">

                            <h5 className="subscription-edit-card-title mb-0 d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="invoice-checkbox"
                                    className="subscription-edit-checkbox"
                                    checked={showInvoice}
                                    onChange={(e) => setShowInvoice(e.target.checked)}
                                />
                                <InvoiceIcon />
                                Quiero la factura electrónica de la orden
                            </h5>

                            {showInvoice && (
                                <div className="w-100 d-flex flex-column gap-3 mt-3">
                                    <div className="w-100">
                                        <label className="form-label">NIT / Número de identificación Tributaria</label>
                                        <input
                                            type="text"
                                            className="subscription-edit-input form-control"
                                            placeholder="Ej. 900.123.456-7"
                                            value={invoiceData.nit}
                                            onChange={(e) => handleInvoiceDataChange("nit", e.target.value)}
                                        />
                                    </div>
                                    <div className="w-100 d-flex gap-3">
                                        <div className="flex-grow-1 w-50">
                                            <label className="form-label">Régimen Fiscal</label>
                                            <Dropdown className="w-100 subscription-edit-select">
                                                <Dropdown.Toggle className="w-100 d-flex justify-content-between align-items-center subscription-edit-select-btn">
                                                    {invoiceData.fiscalRegime
                                                        ? TAX_REGIME_OPTIONS.find(opt => opt.value === invoiceData.fiscalRegime)?.label
                                                        : "Seleccionar ..."}
                                                    <ChevronDownIcon />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="subscription-edit-select-menu w-100">
                                                    {TAX_REGIME_OPTIONS.map(opt => (
                                                        <Dropdown.Item
                                                            key={opt.value}
                                                            onClick={() => handleInvoiceDataChange("fiscalRegime", opt.value)}
                                                        >
                                                            {opt.label}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>

                                        <div className="flex-grow-1 w-50">
                                            <label className="form-label">Responsabilidad Fiscal</label>
                                            <Dropdown className="w-100 subscription-edit-select">
                                                <Dropdown.Toggle className="w-100 d-flex justify-content-between align-items-center subscription-edit-select-btn">
                                                    {invoiceData.fiscalResponsibility
                                                        ? TAX_RESPONSIBILITY_OPTIONS.find(opt => opt.value === invoiceData.fiscalResponsibility)?.label
                                                        : "Seleccionar ..."}
                                                    <ChevronDownIcon />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="subscription-edit-select-menu w-100">
                                                    {TAX_RESPONSIBILITY_OPTIONS.map(opt => (
                                                        <Dropdown.Item
                                                            key={opt.value}
                                                            onClick={() => handleInvoiceDataChange("fiscalResponsibility", opt.value)}
                                                        >
                                                            {opt.label}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="w-100">
                                        <label className="form-label">Correo para la facturación</label>
                                        <div className="subscription-edit-input-icon position-relative">
                                            <div className="input-icon-left">
                                                <EmailIcon />
                                            </div>
                                            <input
                                                type="email"
                                                className="subscription-edit-input form-control"
                                                placeholder="contabilidad@tuempresa.com"
                                                value={invoiceData.invoiceEmail}
                                                onChange={(e) => handleInvoiceDataChange("invoiceEmail", e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <button
                                className="subscription-edit-cancel d-flex flex-row gap-2 justify-content-center align-items-center align-self-center "
                                onClick={() => {
                                    navigate("/admin/edit-member/cancel", { state: { planData: planData, action: "cancel" } });
                                }}
                            >
                                <CancelIcon />
                                Cancelar suscripción
                            </button>
                        </div>
                    </>
                )}
            {showPlansModal && (
                <PlansModal
                    show={showPlansModal}
                    onHide={() => setShowPlansModal(false)}
                    source="edit"
                    onPlanSelected={handlePlanSelectionFromModal}
                    initialBillingPeriod={billingPeriod}
                />
            )}
        </div>
    );
}

export { TAX_REGIME_OPTIONS, TAX_RESPONSIBILITY_OPTIONS };